module.exports = __webpack_public_path__ + "img/banner15.9554462d.png";